var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUndo24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.606,
    height: 5.103,
    viewBox: "0 0 11.606 5.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.953,7.567A5.933,5.933,0,0,0,4.041,9.041L2,7v5.1H7.1L5.05,10.05A4.519,4.519,0,0,1,12.262,12.1l1.344-.442A5.961,5.961,0,0,0,7.953,7.567Z",
    transform: "translate(-2 -7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUndo24Px);
export default __webpack_public_path__ + "static/media/ic_undo_24px.5bd3c1ef.svg";
export { ForwardRef as ReactComponent };